module.exports = __webpack_public_path__ + "9f348d6b43d2faefb3a1fd926866e8c6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/14_C#3.mp3
// module id = 94
// module chunks = 0